import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { dteApi } from "../lib/api";
import { useAuth } from "./AuthContext";
import { IS_LOCAL_EDITION } from "../lib/edition";

const AmbienteContext = createContext(null);

export const AMBIENTE_PRUEBAS = "00";
export const AMBIENTE_PRODUCCION = "01";

export function AmbienteProvider({ children }) {
  const { user } = useAuth();
  const [ambiente, setAmbiente] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (IS_LOCAL_EDITION) {
      setAmbiente(AMBIENTE_PRODUCCION);
      setLoading(false);
      return;
    }
    if (!user) {
      setAmbiente(null);
      setLoading(false);
      return;
    }
    try {
      const result = await dteApi.getAmbiente();
      setAmbiente(result.ambiente_activo || AMBIENTE_PRODUCCION);
    } catch (_) {
      // Fail closed: a temporary read error must not expose test operations.
      setAmbiente(AMBIENTE_PRODUCCION);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    reload();
  }, [reload]);

  const setAmbienteRemote = useCallback(async (next) => {
    if (IS_LOCAL_EDITION) {
      setAmbiente(AMBIENTE_PRODUCCION);
      return { ambiente_activo: AMBIENTE_PRODUCCION, label: "Producción" };
    }
    const result = await dteApi.putAmbiente(next);
    setAmbiente(result.ambiente_activo || AMBIENTE_PRODUCCION);
    return result;
  }, []);

  const value = {
    ambiente,
    loading,
    isPruebas: ambiente === AMBIENTE_PRUEBAS,
    isProduccion: ambiente === AMBIENTE_PRODUCCION,
    label: ambiente === AMBIENTE_PRUEBAS ? "Pruebas" : "Producción",
    setAmbiente: setAmbienteRemote,
    reload,
  };
  return <AmbienteContext.Provider value={value}>{children}</AmbienteContext.Provider>;
}

export function useAmbiente() {
  const ctx = useContext(AmbienteContext);
  if (!ctx) throw new Error("useAmbiente fuera de AmbienteProvider");
  return ctx;
}
